<template>
    <transition name="warning-container">
        <div class="warning-popup d-flex justify-content-center align-items-start" :class="{ 'animation-warning': !hideCloseBtn }">
            <div class="warning-container col-xl-6 col-lg-8 col-10 neue-roman" :class="this.warning.warningType">
                <div class="warning-wrapper d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center" :class="{ 'col-11': !this.hideCloseBtn}">
                        <!-- <div class="warning-picture">
                            <div>
                                <Icon :name="this.warningType" size="c32" />
                            </div>
                        </div> -->
                        <div class="warning-text-info col-12" :style="{ 'font-size': `${this.fontSize}px` }">
                            <div class="warning-text" :class="{ 'neue-roman': this.fontSize == '14', 'neue': this.fontSize == '16' }">
                                {{ this.warning.warningText ? this.warning.warningText : '' }}
                            </div>
                        </div>
                    </div>
                    <div v-if="!this.hideCloseBtn" class="warning-close d-flex align-items-center flex-shrink-0 justify-content-center" @click="this.closePopup()">
                        <Icon :name="'close'" :color="this.warning.warningType" size="c20" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Icon from "@/components/icons/Icon.vue";
export default {
    components: {
        Icon
    },
    data() {
        return {
            t: false
        }
    },
    props: {
        warning: {
            type: Object,
            required: true
        },
        hideCloseBtn: {
            type: Boolean,
            default: false
        },
        fontSize: {
            type: String,
            default: '16'
        }
    },
    methods: {
        closePopup() {
            this.$emit('close', this.warning.id)
        }
    },
    mounted() {
        this.t = setTimeout(() => {
            this.closePopup();
        }, 30000);
    },
    beforeUnmount() {
        if (this.t) {
            clearTimeout(this.t);
        }
    }
}
</script>

<style lang="scss" scoped>
    .warning-popup { 
        outline: none;
        overflow: auto;
        background-color: #FFFFFF;
        border-radius: 8px;
    }
    
    .animation-warning {
        opacity: 0;
        margin: 0 12px;
        animation: ani 0.3s forwards;
    }
    
    @keyframes ani {
        0% {opacity: 0;}
        100% {opacity: 1;}
    }

    .warning-container {
        width: 100%;
        color: #fff;
        padding: 15px;
        border: 1px solid;
        border-left: 8px solid;
        border-radius: 8px;

        // @media (min-width: 516px) {
        //     max-width: 500px;
        // }
    }

    .warning-close {
        cursor: pointer;
        border: 1px solid;
        border-radius: 8px;
        width: 40px;
        height: 40px;
    }

    .warning-picture,
    .warning-text-info {
        margin-right: 20px;
    }

    .warning-info {
        background: $color-grey!important;
    }

    .notification {
        background-color: rgba($color-notification, 0.1)!important;
        border-color: $color-notification!important;
        color: $color-notification!important;
    }

    .warning-money {
        background: $menu-bg-search!important;
    }

    .warning-keyt {
        background: $dark-orange!important;
    }

    .error {
        background-color: rgba($color-invalid, 0.1)!important;
        border-color: $color-invalid!important;
        color: $color-invalid!important;
    }
    .warning {
        background-color: $color-orange-light !important;
        border-color: $dark-orange !important;
        color: $dark-orange !important;
    }
</style>